import { Palette } from '@/themes/themeOverrides/Palette';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';

export const MuiPopoverStyles = {
    styleOverrides: {
        root: {
            '& .MuiPaper-root .MuiBox-root, & .MuiPaper-root .MuiList-root': {
                background: Palette.white,
                boxShadow: Palette.boxShadow.elevation8,
                borderRadius: '12px',
                padding: 0,
                overflow: 'hidden',
            },
            '&.MuiMenu-root .MuiPaper-root .MuiButtonBase-root:hover': {
                background: Palette.yellow.yellow50,
            },
            '& .MuiPaper-root .MuiList-root .color-box': {
                borderRadius: '4px !important',
                width: '24px',
                height: '24px',
                maxHeight: '24px',
                maxWidth: '24px',
                minWidth: '24px',
                minHeight: '24px',
                overflow: 'visible',
                marginLeft: '-8px',
            },
            '&.mobile-filters-popover .mobile-filters-details form': {
                display: 'block',
            },
            '&.more-area': {
                zIndex: '1200',
                '&.more-area-in-details': {
                    zIndex: '999999 !important',
                    '& + .MuiDialog-root.MuiModal-root': {
                        zIndex: '9999999 !important',
                    },
                    '& .MuiPaper-root.MuiPaper-elevation': {
                        marginTop: '2px !important',
                    },
                },
                '& .MuiPopover-paper .MuiBox-root': {
                    backgroundColor: Palette.white,
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '8px',
                    alignItems: 'flex-start',
                },
            },
            '&.MuiPopover-root[id^="menu-"]': {
                '& .MuiPaper-root': {
                    marginTop: '4px',
                    marginLeft: '-1px',
                    width: 'min-content',
                    '& [aria-labelledby="deploymentStatus-label"]': {
                        '& .MuiMenuItem-root': {
                            textWrap: 'auto',
                        },
                    },
                    '& .MuiButtonBase-root': {
                        '&:hover': {
                            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                },
            },
            '&.from-to-filter': {
                '& .MuiPaper-root .MuiBox-root': {
                    overflow: 'visible',
                },
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    position: 'static',
                    width: '100%',
                    '& .MuiPaper-root.MuiPaper-elevation': {
                        transition: 'none !important',
                    },
                },
                '& .MuiPaper-root.MuiPaper-elevation': {
                    transition: 'none !important',
                    overflow: 'visible',
                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                        position: 'static !important',
                        transform: 'none !important',
                        transformOrigin: 'none !important',
                        top: 'auto !important',
                        left: 'auto !important',
                        right: 'auto !important',
                        bottom: 'auto !important',
                        width: '100% !important',
                        minWidth: '100% !important',
                        maxWidth: '100% !important',
                    },
                },
                '& .from-to-filter-popup': {
                    display: 'block',
                    overflow: 'visible',
                    '&--time': {
                        '& .MuiTypography-caption': {
                            maxWidth: '200px',
                        },
                    },
                    '& .MuiBox-root': {
                        boxShadow: 'none',
                    },
                    '& .time-picker, & .date-picker': {
                        overflow: 'visible',
                    },
                    '& .rs-picker-popup': {
                        zIndex: 1,
                        [`@media (max-width: ${breakpoints.values.md}px)`]: {
                            zIndex: 1300,
                        },
                    },
                    '& .MuiOutlinedInput-root': {
                        maxWidth: '121px',
                    },
                    '& .inputs': {
                        overflow: 'visible',
                        padding: '0px 24px 14px 24px',
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '12px',
                        [`@media (max-width: ${breakpoints.values.md}px)`]: {
                            boxSizing: 'border-box',
                            width: '100%',
                            marginTop: '10px',
                        },
                        '& > .MuiFormControl-root': {
                            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                minWidth: '50% !important',
                                border: 'none',
                                padding: '0',
                            },
                            '& .MuiInputBase-root': {
                                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                    minWidth: '100%',
                                },
                            },
                            '& .MuiFormHelperText-root': {
                                display: 'none',
                            },
                        },
                        '.date-picker': {
                            '.rs-picker': {
                                maxWidth: '110px',
                            },
                        },
                        '& .time-picker': {
                            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                maxWidth: '110px',
                            },
                        },
                    },
                    '& .actions': {
                        width: '100%',
                        boxSizing: 'border-box',
                        borderTop: `2px solid ${Palette.gray.gray50}`,
                        padding: '24px',
                        '& .MuiButton-root': {
                            width: '100%',
                        },
                    },
                    '& .MuiTypography-h6': {
                        fontFamily: 'Inter',
                        padding: '20px 24px 0px 24px',
                        fontSize: '10px',
                        fontStyle: 'normal',
                        fontWeight: '700',
                        lineHeight: '12px',
                        letterSpacing: '0.4px',
                        textTransform: 'uppercase',
                    },
                },
            },
        },
        paper: {
            '&.MuiPaper-rounded.MuiPopover-paper': {
                borderRadius: '16px',
                boxShadow: Palette.boxShadow.elevation8,
                display: 'flex',
                flexDirection: 'column',
                marginTop: '2px',
                '& .MuiMenu-list': {
                    flexGrow: 1,
                    overflowY: 'auto',
                },
            },
            '& .MuiList-padding.MuiMenu-list': {
                padding: '13px !important',
                '& .MuiMenuItem-root': {
                    borderRadius: '8px',
                    fontSize: '14px',
                    padding: '8px 16px',
                    '&.Mui-selected': {
                        backgroundColor: Palette.gray.gray100,
                    },
                    '&[aria-checked="true"]': {
                        display: 'none',
                    },
                },
            },
        },
    },
};
